import { DetailRecordFallback } from 'components/common';
import { EMPTY_RECORD, useDetailRecord } from 'helpers/detailRequest';
import { useParams } from "react-router-dom"
import EmployeeDetailHeader from "./EmployeeDetailHeader"
import EmployeeDetailInfo from "./EmployeeDetailInfo"
import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getEmployee } from "redux/organization/employeeSlice"

const EmployeeDetail = () => {
  const params = useParams();
  // Only the record in the URL — the persisted store can still hold the one
  // viewed last (e.g. when opened from an email link).
  const { record, waiting, error } = useDetailRecord('organization_employee', params.id);
  const employee = record || EMPTY_RECORD;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getEmployee(params.id));
  }, [params, dispatch])

  if (!record) return <DetailRecordFallback waiting={waiting} title="Employee not available" error={error} onRetry={() => dispatch(getEmployee(params.id))} />;

  return (
    <>
      <EmployeeDetailHeader employee={employee} />
      <EmployeeDetailInfo employee={employee} />
    </>
    
  )
}

export default EmployeeDetail
